<template>
    <div class="container full-spec">
        <h3 class="full-spec__title">Full vehicle specification</h3>
        <span>For {{ vehicle.manufacturer }} {{ vehicle.model }} {{ vehicle.body }} {{ vehicle.version }}.</span>

        <div class="swiper" ref="buttons">
            <div class="swiper-wrapper full-spec__buttons-wrapper">
                <div class="swiper-slide full-spec__button" v-for="(specs, category) in features"
                    :class="{ 'full-spec__button--active': activeCategory === category }"
                    @click="setActiveSpecs(category, specs)" :key="category">
                    {{ category }}
                </div>
            </div>
        </div>

        <ul class="full-spec__specs-grid">
            <li v-for="(spec, index) in activeSpec" :key="index" v-html="spec"></li>
        </ul>
    </div>
</template>

<script>
import Swiper from "swiper";

export default {
    data() {
        return {
            activeCategory: null,
            activeSpec: null,
            swiper: null,
        }
    },
    props: {
        vehicle: {
            type: Object,
            required: true
        }
    },
    computed: {
        features() {
            if (
                typeof this.vehicle.used_vehicle_tech_specs	 == "undefined" || Object.keys(this.vehicle.used_vehicle_tech_specs	).length == 0 || typeof this.vehicle.used_vehicle_features == "undefined" || this.vehicle.used_vehicle_features.length == 0) {
                return [];
            }
            let features = {};

            Object.keys(this.vehicle.used_vehicle_tech_specs).forEach(key => {
                const item = this.vehicle.used_vehicle_tech_specs[key];
                if (typeof features['General'] == "undefined") {
                    features['General'] = [];
                }

                features['General'].push(`<strong>${item.key}:</strong> ${item.value}`);
            });

            this.vehicle.used_vehicle_features.forEach((element) => {
                let category = element.category;
                if (category == "Audio and Communications") {
                    category = "Audio";
                }
                if (typeof features[category] == "undefined") {
                    features[category] = [];
                }
                features[category].push(element.feature);
            });
            return features;
        },
    },
    methods: {
        setupSwiper() {
            this.$nextTick().then(() => {
                this.swiper = new Swiper(this.$refs["buttons"], {
                    grabCursor: true,
                    slidesPerView: "auto",
                    spaceBetween: 10,
                    speed: 400,
                    direction: "horizontal",
                });
            })
        },
        setActiveSpecs(category, specs) {
            this.activeCategory = category;
            this.activeSpec = specs;
        },
    },
    mounted() {
        this.setActiveSpecs(Object.keys(this.features)[0], this.features[Object.keys(this.features)[0]]);
        this.setupSwiper();
    },
}
</script>

<style lang="scss" scoped>
@import "../../../../../node_modules/vue-slick-carousel/dist/vue-slick-carousel.css";
@import "../../../../../node_modules/vue-slick-carousel/dist/vue-slick-carousel-theme.css";
@import "../../../sass/redesign/variables";

.full-spec {
    margin-top: 30px;
    margin-bottom: 30px;

    &__title {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 0;
        margin-bottom: 10px;
        color: $dark-blue;
    }

    &__sub-title {
        font-size: 16px;
    }

    &__buttons-wrapper {
        margin-top: 25px;
    }

    &__button {
        height: 45px;
        width: unset;
        min-width: 35vw;
        border: solid 2px $rd-pop-blue;
        border-radius: 10px;
        text-align: center;
        line-height: 42px;
        font-size: 16px;
        font-weight: 700;
        color: $rd-pop-blue;
        padding-left: 10px;
        padding-right: 10px;

        @media (min-width: $screen-xs) {
            min-width: 40vw;
        }

        @media (min-width: $screen-sm) {
            min-width: 175px;
        }

        &--active {
            background-color: $rd-pop-blue;
            color: #fff;
        }
    }

    &__specs-grid {
        display: grid;
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 10px;
        padding-left: 0;

        @media (min-width: $screen-md) {
            grid-template-columns: repeat(3, minmax(0, 1fr));
        }

        li {
            list-style: none;
            color: #4a4a4a;
            padding: 12px 16px;
            border-radius: 6px;
            display: flex;
            justify-content: space-between;
        }

        @media (max-width: $screen-sm-max) {
            li:nth-child(2n),
            li:nth-child(2n-1) {
                background-color: #e5f4fa;
            }

            li:nth-child(4n),
            li:nth-child(4n-1) {
                background-color: #fff;
            }
        }

        @media (min-width: $screen-md) {
            li:nth-child(3n),
            li:nth-child(3n-1),
            li:nth-child(3n-2) {
                background-color: #e5f4fa;
            }

            li:nth-child(6n),
            li:nth-child(6n-1),
            li:nth-child(6n-2) {
                background-color: #fff;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/FullSpec.vue